import {
  Form,
  Button
} from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import LoginScreen from "../views/components/LoginScreen";
import PasswordField from "../views/components/PasswordField";
import { useEffect, useState } from "react";
import {
  validateEmail,
  validatePassword
} from "../views/helpers";
import { loginUser, verifyCode } from "../data/dataApi";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState();
  const [emailError, setEmailError] = useState();
  const [password, setPassword] = useState();
  const [passwordError, setPasswordError] = useState();
  const [unexpectedError, setUnexpectedError] = useState();

  const navigate = useNavigate();

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const loginEmail = query.get('email');
  const verificationCode = query.get('verificationCode');

  const authPreCheck = async () => {
    setEmailError(null);
    setPasswordError(null);

    if(validateEmail(email, setEmailError) === "success" && validatePassword(password, setPasswordError) === "success") {
      const response = await loginUser(email, password);

      if(response.success) {
        navigate("/home", { replace: true });
      } else if(response.error.field === "email") {
        setEmailError(response.error.message);
      } else if(response.error.field === "password") {
        setPasswordError(response.error.message);
      } else if(!response.error.field) {
        setUnexpectedError(response.error.message);
      }
    }
  };

  useEffect(() => {
    if(loginEmail && verificationCode) {
      (async () => {
        const response = await verifyCode(loginEmail, verificationCode);
      
        if(response.success) {
          navigate("/home", { replace: true });
        }
      })();
    }
  }, []);

  return (
    <LoginScreen>
      <h1 className="tif-h2 tif-mb-15">Login</h1>
      <p className="tif-mb-sm-70 tif-mb-35 tif-ls-25">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor</p>

      <Form className="primary-form">
        <Form.Group className="form-group tif-mb-sm-30 tif-mb-20" controlId="formEmail">
          <Form.Label>Email Address</Form.Label>
          <Form.Control type="email" className={ emailError ? "has-error" : "" } placeholder="example@email.com" onChange={e => setEmail(e.target.value)} />
          { emailError && <p className="error-text">{ emailError }</p> }
        </Form.Group>

        <Form.Group className="form-group tif-mb-sm-85 tif-mb-45" controlId="formPassword">
          <Form.Label>Password</Form.Label>
          <PasswordField onChange={ setPassword } error={ !!passwordError } />
          { passwordError && <p className="error-text">{ passwordError }</p> }
          <Form.Text className="text-muted tif-font-sm forgot-password-label tif-mt-sm-10 tif-mt-5 d-block">Forgot password? <Link to="/reset-password">Reset here</Link></Form.Text>
        </Form.Group>

        { unexpectedError && <p className="error-text">{ unexpectedError }</p> }

        <Button className="primary-btn" onClick={ authPreCheck }>Login</Button>
      </Form>
    </LoginScreen>
  );
};

export default Login;